/**
 * Legacy Navigation Guard
 *
 * Replicates the sidebar/topbar visibility logic from src/router.js beforeEach.
 * This guard is called from the v2 router for legacy routes.
 *
 * TODO: Remove this file once all legacy routes are migrated to v2
 */
import type { RouteLocationNormalized } from 'vue-router';
import store from '@/store';

const showTopbarRoutes = [
  'Dashboard',
  'Drafts',
  'My Debates',
  'Templates',
  'Create Debate',
  'Create Template',
  'Document',
  'Debate',
  'CuratorDebate',
  'PublicDebate',
  'Document Annotations',
  'Public View',
  'Analyze document for Discussion',
  'Edit Automate Outline for Discussion',
];

const hideTopbarRoutes = [
  'Organizations',
  'AccountDetails',
  'Discussions',
  'Inbox',
  'Contacts',
  'Team Settings',
  'Document Details',
];

/**
 * Apply legacy sidebar/topbar visibility logic based on route name.
 * Call this in router.beforeEach for legacy routes only.
 */
export function applyLegacyVisibility(to: RouteLocationNormalized): void {
  const routeName = to.name as string;

  if (showTopbarRoutes.includes(routeName)) {
    store.commit('hideSidebar');
    store.commit('showTopbar');
  } else if (hideTopbarRoutes.includes(routeName)) {
    store.commit('showSidebar');
    store.commit('hideTopbar');
  } else {
    store.commit('showSidebar');
  }
}
